import clsx from "clsx";
import { Tab } from "./types";

const PillTab = ({ tab }: { tab: Tab }) => {
    const active = tab.path === window.location.pathname;

    return (
        <button
            role="tab"
            onClick={"onClick" in tab ? tab.onClick : undefined}
            className={clsx("px-4 py-2 rounded-full text-sm font-medium transition-colors cursor-pointer", {
                "bg-white text-gray-900 shadow": active,
                "text-gray-600 hover:text-gray-900": !active,
            })}>
            {tab.label}
        </button>
    );
}

export { PillTab }